<!--title -->
<app-modal-title
  [title]="formPageConfig.title | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form">
    <div class="row">
      <div class="tw-w-full">
        <div class="tw-flex flex-column tw-justify-center tw-items-center">
          <div class="tw-w-[350px]">
            <mobile-numbers-widget
              [title]="'common.numberList' | translate"
              uniqId="numbers"
              [correctRows]="10"
              [wrongRows]="10"
              responsiveClass="tw-w-full"
              [form]="form"
              controlName="mobiles"
              [isCompressionMobiles]="false"
              (mobileNumbers)="getMobiles($event)"
            >
            </mobile-numbers-widget>
          </div>
        </div>
      </div>
    </div>

    <!-- form btns-->
    <app-form-btns
      [loading]="loading"
      [form]="form"
      [isEdit]="formPageConfig.isEditMode"
      (onClose)="onClose()"
      (onSubmit)="onSubmit()"
    >
    </app-form-btns>
  </form>
</div>
